import { Component, inject, input, signal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoPipe } from '@jsverse/transloco';
import { produce } from 'immer';
import { GuidelineService } from 'shared/domain';

import { ComponentWidget, GuidelineObservationComponent, UnitDto } from '@treetop/shared/model';
import { GuidelineElementSection, GuidelineElementType } from '@treetop/shared/reference-numbering';

import { DividerComponent } from '../../../../../../../../shared/ui-common/src/lib/components/divider/divider.component';
import { TitleDescriptionComponent } from '../../../chapter-sidebar-wrapper/components/title-description/title-description.component';
import {
  GuidelineSidebarBasics,
  GuidelineSidebarBasicsComponent,
} from '../../../guideline-sidebar-basics/guideline-sidebar-basics.component';
import { TechnicalInfoComponent } from '../../../sub-components/technical-info/technical-info.component';
import { UnitMolarComponent } from '../../../sub-components/unit-molar/unit-molar.component';

@Component({
  standalone: true,
  imports: [
    MatTabsModule,
    TranslocoPipe,
    TitleDescriptionComponent,
    UnitMolarComponent,
    TechnicalInfoComponent,
    GuidelineSidebarBasicsComponent,
    GuidelineSidebarBasicsComponent,
    DividerComponent,
  ],
  selector: 'guideline-component-sidebar-observation',
  templateUrl: './guideline-component-sidebar-observation.component.html',
  styleUrls: ['./guideline-component-sidebar-observation.component.scss'],
})
export class GuidelineComponentSidebarObservationComponent {
  private guidelineService = inject(GuidelineService);

  public widget = input.required<ComponentWidget<GuidelineObservationComponent>>();

  protected showAllMedications = signal(false);

  protected handleTitleChanged(title: string): void {
    const newWidget = produce(this.widget(), (draft) => {
      draft.component.title = title;
    });

    this.guidelineService.updateWidget(newWidget.uniqueId, newWidget);
  }

  protected onUnitMolarChanged(unit: UnitDto) {
    const newWidget = produce(this.widget(), (draft) => {
      if (!draft.component.observationDefinition) {
        draft.component.observationDefinition = {};
      }

      draft.component.observationDefinition.unit = unit;
      draft.component.observationDefinition.unitId = unit?.id;
    });

    this.guidelineService.updateWidget(newWidget.uniqueId, newWidget);
  }

  protected handleBasicsChanged(basics: GuidelineSidebarBasics) {
    const newWidget = produce(this.widget(), (draft) => {
      draft.references = basics.references;
      draft.links = basics.links;
      draft.attachments = basics.attachments;
      draft.resourceTags = basics.resourceTags;
    });

    this.guidelineService.updateWidget(newWidget.uniqueId, newWidget);
  }

  protected readonly GuidelineElementSection = GuidelineElementSection;
  protected readonly GuidelineElementType = GuidelineElementType;
}
